/**
 * Time-display helper.  The internal unit is always AW (1 AW = 6 minutes,
 * 10 AW = 1 hour).  The visible representation is controlled by the workshop
 * setting `time_display_mode`:
 *   - "aw"     →  "80 AW"
 *   - "hours"  →  "8 h"    (integer)  |  "4.5 h" (one decimal)  |  "1.25 h" (quarter-hour precision)
 *   - "both"   →  "80 AW / 8 h"
 * We deliberately avoid a fixed number of decimals so that quarter-hour
 * increments (0.25 / 0.5 / 0.75 h) are never rounded away.
 */
export const HOURS_PER_AW = 1 / 10;

export function awToHours(aw) {
  const v = Number(aw) || 0;
  return v * HOURS_PER_AW;
}

/** Render an hours value with just enough precision:
 *   3    → "3"
 *   3.5  → "3.5"
 *   3.25 → "3.25"
 *   3.10 → "3.1"
 * Never shows trailing zeros, never rounds beyond two decimals.
 */
export function formatHoursValue(h) {
  const rounded = Math.round((Number(h) || 0) * 100) / 100;
  if (Number.isInteger(rounded)) return String(rounded);
  // 2 decimals then strip a trailing zero (e.g. "3.50" → "3.5")
  return rounded.toFixed(2).replace(/0$/, "").replace(/\.$/, "");
}

export function formatWorkTime(aw, mode = "aw", t) {
  const awNum = Number(aw) || 0;
  const hours = awToHours(awNum);
  const hLabel = (t && t("planning.hours_short")) || "h";
  // "AW" is always rendered as an integer for a clean look.
  const awStr = `${Math.round(awNum)} AW`;
  const hStr = `${formatHoursValue(hours)} ${hLabel}`;
  switch (mode) {
    case "hours": return hStr;
    case "both":  return `${awStr} / ${hStr}`;
    case "aw":
    default:      return awStr;
  }
}

export function formatCapacity(currentAw, totalAw, mode = "aw", t) {
  return `${formatWorkTime(currentAw, mode, t)} / ${formatWorkTime(totalAw, mode, t)}`;
}
